module.exports = __webpack_public_path__ + "media/27 sparkle with.b6098ac2.mp3";